import { isEmpty } from 'lodash'

import { getRevenueCenterMenuUuids } from './getRevenueCenterMenuUuids'

// return boolean: true when all his children are checked or if
// particular revenueCenterUuid is already in selectedRevenueCentersAndMenusUuids
export const getIsCheckedRevenueCenterCheckbox = (
  filteredMenusAndRevenueCenters,
  selectedRevenueCentersAndMenusUuids,
  uuid
) => {
  if (isEmpty(uuid) || isEmpty(filteredMenusAndRevenueCenters))
    return false

  // uuids of menus assigned to revenue center
  const revenueCenterMenusUuids = getRevenueCenterMenuUuids(
    filteredMenusAndRevenueCenters,
    uuid
  )

  const isAllMenusChecked =
    revenueCenterMenusUuids?.every((uuid) =>
      selectedRevenueCentersAndMenusUuids?.includes(uuid)
    ) ?? false

  return (
    (isAllMenusChecked ||
      selectedRevenueCentersAndMenusUuids?.includes(uuid)) ??
    false
  )
}
